import React from 'react';
import '../css/Footer.css'

function Footer() {
    return <footer className="footerr mt-auto">
        Copyright <i className="far fa-copyright"></i>
        {new Date().getFullYear()}.
        Easy Software Pvt.Ltd | All Right Reserved
    </footer>;
}

export default Footer;
